import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG_empty.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import { PresetColors } from "./LeftSidebar/EditTab";
import { useTranslation } from "react-i18next";
import { getOneLetterResult } from "../../../../frontend/templates/fcb/MatchdaySlider/Index";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";

const FCBSlider2Content = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;

    const { options, fields, dynamic, editData } = data.data;
    const {
        totalScores,
        homeTeamScorers,
        awayTeamScorers,
    } = data?.data?.dynamic;

    const homeTeam = data?.event?.home;
    const awayTeam = data?.event?.away;
    let statsLeftTeam = homeTeam;
    let statsRightTeam = awayTeam;
    if (statsRightTeam.shortcut == 'FCB') {
        statsLeftTeam = awayTeam;
        statsRightTeam = homeTeam;
    }
    const manualEntries = props.manualEntries;

    const competitionId = data?.event?.competitionId;

    const date = data?.event?.date;
    const time = data?.event?.time;
    const [day, month, year] = date.split(".");
    const dateTimeString = `${year}-${month}-${day}T${time}`;
    const basetime = new Date(dateTimeString);
    const quoteText = getContentById("quote", fields);
    const author = getContentById("author", fields);
    const customBackground = getContentById("background", fields, "self");
    const homeWins = totalScores?.homeWins || 0;
    const homeDraws = totalScores?.homeDraws || 0;
    const homeLoss = totalScores?.homeLoss || 0;

    let numberOfWins = homeWins
    let numberOfDraws = homeDraws
    let numberOfLosses = homeLoss;
    if (isNaN(numberOfWins)) {
        numberOfWins = 0;
    }
    if (isNaN(numberOfDraws)) {
        numberOfDraws = 0;
    }
    if (isNaN(numberOfLosses)) {
        numberOfLosses = 0;
    }

    if (!!manualEntries) {
        const { win, draw, loss } = manualEntries;

        const valid =
            [win, draw, loss].some(v => v !== 0) &&    // at least one is not zero
            [win, draw, loss].every(v => !isNaN(v));   // none are NaN

        if (valid) {
            // safe to use manualEntries
            numberOfWins = manualEntries.win;
            numberOfDraws = manualEntries.draw;
            numberOfLosses = manualEntries.loss;
        }
    }

    const numberOfMatches = Math.max(numberOfWins, 0.5) + Math.max(numberOfDraws, 0.5) + Math.max(numberOfLosses, 0.5);
    const { t } = useTranslation();
    const selectedLang = data?.lang;
    const mapValue = (val, inMin = 8, inMax = 76, outMin = 52, outMax = 92) => {
        const mapped =
            ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;

        // clamp between outMin and outMax
        return Math.min(Math.max(mapped, outMin), outMax);
    };

    const totalWidthInPixel = 823;
    const winWidth = (Math.max(numberOfWins, 0.5) / numberOfMatches) * totalWidthInPixel;
    const drawWidth = ((Math.max(numberOfDraws, 0.5)) / numberOfMatches) * totalWidthInPixel;
    const lossWidth = (Math.max(numberOfLosses, 0.5) / numberOfMatches) * totalWidthInPixel;
    const drawFakePolygon = (100 - mapValue((Math.max(numberOfWins, 0.5) / numberOfMatches) * 100)) / 100;
    const drawFakeBarWidth = winWidth * drawFakePolygon;
    const cutWidthPixel = 20;

    const mapValuePixel = (_width) => {
        return _width - cutWidthPixel;
    }
    return (
        <div id={id} className="T_fcb_matchday_slider_2" style={{ zIndex: 101, }}>
            <div className={"wc-content wc-content-v2"}
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white'
                }}
            >
                <div className="gradient-full"></div>
                <div class="match-stats-container-wrap">
                    <div class="match-stats-container">
                        <div
                            class="progress-segment wins"
                            style={{
                                width: `${winWidth}px`,
                            }}
                        >
                            <div className={`logo`}>
                                <TeamLogo team={homeTeam} competitionId={competitionId} />
                            </div>
                            <div className="bar"
                                style={{
                                    clipPath: `polygon(0 0, ${mapValuePixel(winWidth)}px 0, 100% 30%, 100% 100%, ${cutWidthPixel}px 100%, 0 70%)`
                                }}>
                            </div>
                            <div class="label">
                                {t("W", { keyPrefix: "table", lng: selectedLang })}
                            </div>
                            <div class="value">{numberOfWins}</div>
                            <div class="label-full">{t("Wins", { keyPrefix: "table", lng: selectedLang })}</div>
                        </div>
                        <div
                            class="progress-segment draws"
                            style={{
                                width: `${drawWidth}px`
                            }}
                        >
                            <div
                                className="bar"
                                style={{
                                    clipPath: `polygon(0 0, ${mapValuePixel(drawWidth)}px 0, 100% 30%, 100% 100%, 0 100%)`
                                }}
                            >
                            </div>
                            <div className="bar-fake"
                                style={{
                                    width: `${drawFakeBarWidth}px`,
                                    left: `calc(${-drawFakeBarWidth + 2}px)`
                                }}>
                            </div>
                            <div class="label">{t("D", { keyPrefix: "table", lng: selectedLang })}</div>
                            <div class="value">{numberOfDraws}</div>
                            <div class="label-full">{t("Draws", { keyPrefix: "table", lng: selectedLang })}</div>
                        </div>
                        <div
                            class="progress-segment losses"
                            style={{
                                width: `${lossWidth}px`
                            }}
                        >
                            <div className={`logo`}>
                                <TeamLogo team={awayTeam} competitionId={competitionId} />
                            </div>
                            <div
                                className="bar"
                                style={{
                                    clipPath: `polygon(0 0, ${mapValuePixel(lossWidth)}px 0, 100% 30%, 100% 100%, 0 100%)`
                                }}>
                            </div>
                            <div
                                className="bar-fake"
                                style={{
                                    width: `calc(${drawWidth * mapValue((Math.max(numberOfDraws, 0.5) / numberOfMatches)) / 100 + 2}px)`,
                                    left: `calc(${- drawWidth * mapValue((Math.max(numberOfDraws, 0.5) / numberOfMatches)) / 100}px)`
                                }}>
                            </div>
                            <div class="label">{t("L", { keyPrefix: "table", lng: selectedLang })}</div>
                            <div class="value">{numberOfLosses}</div>
                            <div class="label-full">{t("Losses", { keyPrefix: "table", lng: selectedLang })}</div>
                        </div>
                    </div>
                </div>
                <div className="goal-player-container">
                    <div className="goal-player-home">
                        {/* home team logo */}
                        <div className="home-team-logo-container">
                            <TeamLogo team={homeTeam} competitionId={competitionId} />
                        </div>
                        {/* home team top scorers */}
                        <div className="home-team-table">
                            <div className="home-team-table-head">
                                <div className="content"></div>
                                <div className="goals text-label">
                                    {t("Goals", { keyPrefix: "table", lng: selectedLang })}
                                </div>
                                <div className="assists text-label">
                                    {t("Assits", { keyPrefix: "table", lng: selectedLang })}
                                </div>
                            </div>
                            {
                                homeTeamScorers?.map((entry, index) => {
                                    return (
                                        <div className="home-team-table-row">
                                            <div className="player-name">
                                                {entry.player.name}
                                            </div>
                                            <div className="goals text-value">
                                                {entry.goals}
                                            </div>
                                            <div className="assists text-value">
                                                {entry.assists}
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>

                    <div className="goal-player-away">
                        {/* home team logo */}
                        <div className="home-team-logo-container">
                            <TeamLogo team={awayTeam} competitionId={competitionId} />
                        </div>
                        {/* home team top scorers */}
                        <div className="home-team-table">
                            <div className="home-team-table-head">
                                <div className="content"></div>
                                <div className="goals text-label">
                                    {t("Goals", { keyPrefix: "table", lng: selectedLang })}
                                </div>
                                <div className="assists text-label">
                                    {t("Assits", { keyPrefix: "table", lng: selectedLang })}
                                </div>
                            </div>
                            {
                                awayTeamScorers?.map((entry, index) => {
                                    return (
                                        <div className="home-team-table-row">
                                            <div className="player-name">
                                                {entry.player.name}
                                            </div>
                                            <div className="goals text-value">
                                                {entry.goals}
                                            </div>
                                            <div className="assists text-value">
                                                {entry.assists}
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>

                <div className="custom-quote-container">
                    <div className="quote-shape-wrapper">
                        <div className="quote-shape-box"></div>
                        <div className="quote-shape-box"></div>
                    </div>
                    <div className="quote-text">
                        {quoteText}
                    </div>
                </div>
                <div className="quote-bottom">
                    <div className="quote-line"></div>
                    <div className="quote-author">- {author} -</div>
                </div>
            </div>

        </div>

    );
};

export default FCBSlider2Content;
